function notificationShowDirective($interval) {

	function link(scope, elem, attr) {
		
		scope.prueba = 1;
		var mTimeDalayUpd = 1000 * 60 * 2;// 2minuto
		// Inicia un intervalo que se ejecutará carda cierto tiempo
		var mStopUpd = $interval(scope.lookForNewNotifications, mTimeDalayUpd)
		// detener el intervalo
		elem.on('$destroy', function() {
			$interval.cancel(mStopUpd);
		});
	}

	return {
		scope:{
			//valor dummy para identificar de donde es llamado el controlador, que es compartido con la vista de lista
			isDirective: "@"
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/notificationShowDirective.html';
		},
		//El controlador esta en la ruta ntf/controller/notificatoin.list.ctrl.js
		controller : [ '$scope', '$rootScope', '$state', '$interpolate', 'notificationService', 'notificationResolveService', 'dateUtilService', 'ngToast', 'alertService', '$location', '$window', notificationListCtrlFn ],
		link : link
	};
};

module.directive('notificationShow', [ '$interval', notificationShowDirective ]);
